<template>
  <kye-dept-multiple
    v-model="show"
    :model="model"
    :defaultCheckedKeys="defaultCheckedKeys"
    :defaultExpandedKeys="defaultExpandedKeys"
    :checkStrictly="checkStrictly"
    :showPanel="showPanel"
    :disabledCache="disabledCache"
    :fetchAxios="fetchAxios"
    :fetchData="fetchData"
    :filterData="filterData"
    :formatResult="formatResult"
    :deptSearchResultUrl="deptSearchResultUrl"
    :searchUrl="searchUrl"
    :searchParams="searchParams"
    :formatData="formatData"
    :preloadDeptTree="preloadDeptTree"
    :auth="auth"
    :containLeaf="containLeaf"
    :setCurrentNode="setCurrentNode"
    :hasAllTreeAuth="hasAllTreeAuth"
    ref="kyeDeptMultiple"
    @change="saveSelectedDept"
    @current-node-change="currentNodeChange"
    @deleteAllCheckedNode="deleteAllCheckedNode"
    @deleteCheckedNode="deleteCheckedNode"
  >
    <template slot="treeLabel" slot-scope="{node,data,checkedMapDept}">
      <slot name="treeLabel" :node='node' :data='data' :checkedMapDept="checkedMapDept">
        {{node.label}}
      </slot>
    </template>
  </kye-dept-multiple>
</template>

<script>
  import { setModelValue } from '../../utils'
  export default {
    name: 'dept-multiple-dialog',
    props: {
      model: Object,
      preloadDeptTree: {
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        show: false,
        field: {},
        queryField: {},
        defaultCheckedKeys: [],
        defaultExpandedKeys: [],
        checkStrictly: false,
        showPanel: false,
        disabledCache: true,
        fetchAxios: null,
        fetchData: null,
        filterData: null,
        formatResult: null,
        formatData: null,
        // preloadDeptTree: true,
        auth: null,
        containLeaf: true,
        setCurrentNode: null,
        hasAllTreeAuth: false,
        deptSearchResultUrl: '',
        searchUrl: '',
        searchParams: null
      }
    },
    methods: {
      open (field) {
        this.queryField = field
        let arr = field._queryValue || []
        let ids = arr[0] ? arr[0].value : []
        if (ids.length) {
          this.defaultCheckedKeys = ids
        } else {
          this.defaultCheckedKeys = field.defaultCheckedKeys || (field.$attr && field.$attr.defaultCheckedKeys) || []
        }
        this.defaultExpandedKeys = field.defaultExpandedKeys || (field.$attr && field.$attr.defaultExpandedKeys) || []
        this.checkStrictly = field.checkStrictly || (field.$attr && field.$attr.checkStrictly)
        this.searchCheckedNode = field.searchCheckedNode || (field.$attr && field.$attr.searchCheckedNode)
        this.showPanel = field.showPanel || (field.$attr && field.$attr.showPanel)
        this.disabledCache = field.$attr ? field.$attr.deptCache !== false : field.deptCache !== false
        this.fetchAxios = field.fetchAxios || (field && field.$attr && field.$attr.fetchAxios)
        this.fetchData = field.fetchData || (field.$attr && field.$attr.fetchData)
        this.filterData = field.filterData || (field.$attr && field.$attr.filterData)
        this.formatResult = field.formatResult || (field.$attr && field.$attr.formatResult)
        this.formatData = field.formatData || (field.$attr && field.$attr.formatData)
        // this.preloadDeptTree = field.preloadDeptTree || (field.$attr && field.$attr.preloadDeptTree)
        this.containLeaf = field.containLeaf || (field.$attr && field.$attr.containLeaf)
        this.auth = field.auth || (field.$attr && field.$attr.auth)
        this.hasAllTreeAuth = field.hasAllTreeAuth || (field.$attr && field.$attr.hasAllTreeAuth)
        this.setCurrentNode = field.setCurrentNode || (field.attr && field.attr.setCurrentNode) || (field.$attr && field.$attr.setCurrentNode)
        this.searchUrl = field.searchUrl || (field.$attr && field.$attr.searchUrl)
        this.searchParams = field.searchParams || (field.$attr && field.$attr.searchParams)
        this.deptSearchResultUrl = field.deptSearchResultUrl || (field.$attr && field.$attr.deptSearchResultUrl)
        this.show = true
        this.$nextTick(() => {
          this.$refs.kyeDeptMultiple && this.$refs.kyeDeptMultiple.open()
        })
      },
      saveSelectedDept (data) {
        if (data) {
          const label = data.label
          this.queryField._queryValue = [{ label, value: data.value }]
          this.queryField.queryValue2 = data.value
          let key = this.queryField.propertyName
          // 自定义查询
          if (this.model) {
            setModelValue(data.value, this.model, key)
          }
          // callback change
          let fn = this.queryField.change || (this.queryField.$attr && this.queryField.$attr.change)
          if (fn && typeof fn === 'function') {
            fn(data)
          }
          data.field = this.queryField
          data.key = key
          this.$emit('change', data)
        }
      },
      currentNodeChange (data) {
        this.$emit('current-node-change', data)
      },
      deleteAllCheckedNode () {
        this.$emit('deleteAllCheckedNode')
      },
      deleteCheckedNode (id, data) {
        this.$emit('deleteCheckedNode', id, data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/query-table/dept-multiple-dialog.vue